const POLL_INTERVAL_MS = 2000
const MAX_CONSECUTIVE_ERRORS = 3
const FINAL_STATUSES = ['success', 'fail']
// Терминал провёл операцию, учёт ещё пишется: столько ждём записи от первого такого ответа
const APPLY_GRACE_MS = 15000

// success с applied: false - деньги прошли, бэк дописывает учёт сам. Сверка поля applied не отдаёт:
// для неё (и для старого бэка) success финальный сразу
function isAwaitingApply (operation) {
  return operation.status === 'success' && operation.applied === false
}

/**
 * Опрос операции терминала до финала: fail - сразу, success - когда учёт записан (applied: true).
 * success без записи ждём до APPLY_GRACE_MS и отдаём как есть: вызывающий покажет «ещё записывается».
 * fetchStatus - функция без аргументов, возвращает объект со status (операция платежа или сверка).
 * onTick получает каждый промежуточный ответ (например, status 'unknown').
 * cancel() останавливает опрос: promise тогда не завершается, вызывающий сам меняет состояние.
 */
export function waitForTerminalOperation (fetchStatus, { onTick } = {}) {
  let stopped = false
  let timer = null

  const promise = new Promise((resolve, reject) => {
    let consecutiveErrors = 0
    let awaitingApplySince = null

    const tick = async () => {
      if (stopped) return

      try {
        const operation = await fetchStatus()
        if (stopped) return
        consecutiveErrors = 0
        if (onTick) onTick(operation)

        if (isAwaitingApply(operation)) {
          if (awaitingApplySince === null) awaitingApplySince = Date.now()
          if (Date.now() - awaitingApplySince >= APPLY_GRACE_MS) {
            resolve(operation)
            return
          }
        } else if (FINAL_STATUSES.includes(operation.status)) {
          resolve(operation)
          return
        }
      } catch (e) {
        if (stopped) return
        consecutiveErrors += 1
        if (consecutiveErrors >= MAX_CONSECUTIVE_ERRORS) {
          reject(e)
          return
        }
      }

      if (!stopped) timer = setTimeout(tick, POLL_INTERVAL_MS)
    }

    tick()
  })

  return {
    promise,
    cancel () {
      stopped = true
      clearTimeout(timer)
    },
  }
}

// Бэк доводит команду до финала сам; фронт ждёт дедлайн плюс запас на разбор и отпускает кнопку
const DEADLINE_MARGIN_MS = 30000

/**
 * Ждёт финал команды терминала с дедлайном от бэка: { status, error }.
 * По дедлайну резолвится { status: 'unknown', error: unknownError }.
 * cancel() останавливает опрос, promise тогда не завершается.
 */
export function watchTerminalCommand (fetchStatus, timeoutSeconds, unknownError) {
  const poller = waitForTerminalOperation(fetchStatus)
  let deadlineTimer = null

  const deadline = new Promise(resolve => {
    deadlineTimer = setTimeout(
      () => resolve({ status: 'unknown', error: unknownError }),
      timeoutSeconds * 1000 + DEADLINE_MARGIN_MS,
    )
  })

  const promise = Promise.race([poller.promise, deadline]).finally(() => {
    clearTimeout(deadlineTimer)
    poller.cancel()
  })

  return {
    promise,
    cancel () {
      clearTimeout(deadlineTimer)
      poller.cancel()
    },
  }
}
